import { useMemo, useState } from "react";
import DateSelector from "../../../components/shared/fields/DateSelector";
import GridCard from "../../../components/shared/gridCard/GridCard";
import Button from "../../../components/shared/buttons/button";
import { PlusSvg } from "../../../svgFiles/PlusSvg";
import TotalCase from "../../../images/totalCase.svg";
import KgEntered from "../../../images/material_kg.svg";
import ColdStorage from "../../../images/cold_storage.svg";
import ColdStorageKg from "../../../images/material_orange.svg";
import TotalRipening from "../../../images/ripening_orange.svg";
import RoomKg from "../../../images/material_orange.svg";
import Sorting from "../../../images/sorting.svg";
import RipeningCharts from "./RipeningCharts";
import TotalEmployee from "../../../images/total_emp.svg";
import EmployeeColdStorage from "../../../images/emp_coldStorage.svg";
import EmployeeRipening from "../../../images/emp_ripening.svg";
import EmployeeSorting from "../../../images/emp_sorting.svg";
import AbsentEmployee from "../../../images/emp_absent.svg";
import {
  useGetEmployeeQuery,
  useGetRipeningSummaryQuery,
} from "./ripeingDashboardApi";
import AddRipeningEmployeeData from "./AddRipeningEmployeeData";
import {
  useGetAllWorkingAreasQuery,
  useGetAttendanceOverviewQuery,
} from "../../../app/globalApi";
import { skipToken } from "@reduxjs/toolkit/query";
import GridCardNew from "../../../components/shared/gridCard/GridCardNew";
import EmployeeWashing from "../../../images/emp_washing.svg";
import useTranslator from "../../../hooks/useTranslator";
import { formatDateAndTime, getCurrentDate } from "../../../helpers/Utils";
import { PROJECT_DATE_FORMAT } from "../../../helpers/constants";

const RipeningDashboard = () => {
  const [showAddEmployment, setShowAddEmployment] = useState(false);
  const { _t } = useTranslator();  
  const currentDate = getCurrentDate('YYYY-MM-DD');
  const [date, setDate] = useState(currentDate);
  const [tab, setTab] = useState("dashboard");

  const { data: summaryData } = useGetRipeningSummaryQuery({ tab, date });
  const { data: employeeSummaryData } = useGetEmployeeQuery({
    date: currentDate,
  });

  const { data: workingAreasData, isLoading: isWorkingAreasLoading } =
    useGetAllWorkingAreasQuery();

  const receivingAreaId = useMemo(() => {
    if (!workingAreasData?.data) return null;
    const receivingArea = workingAreasData.data.find(
      (area) => area.name === "Ripening & Selection Area"
    );
    return receivingArea ? receivingArea.id : null;
  }, [workingAreasData]);

  // const {
  //   data: attendanceOverviewData,
  //   isLoading: isAttendanceLoading,
  //   isError: isAttendanceError,
  // } = useGetAttendanceOverviewQuery(
  //   receivingAreaId
  //     ? { working_area_id: receivingAreaId, date: date }
  //     : skipToken
  // );

  const listItems = [
    {
      label: _t("total_on_floor_cases", "Total on Floor Cases"),
      value: summaryData?.data.total_cases_on_floor,
      icon: TotalCase,
    },
    {
      label: _t("total_kg_on_floor", "Total KG on Floor"),
      value: summaryData?.data.total_kg_on_floor,
      icon: KgEntered,
    },
    {
      label: _t("total_cases_cold_storage", "Total Cases in Cold Storage"),
      value: summaryData?.data.total_cases_in_cold_storage,
      icon: ColdStorage,
    },
    {
      label: _t("total_kg_cold_storage", "Total KG in Cold Storage"),
      value: summaryData?.data.total_kg_in_cold_storage,
      icon: ColdStorageKg,
    },
    {
      label: _t("total_cases_ripening", "Total Cases in Ripening"),
      value: summaryData?.data.total_cases_in_ripening,
      icon: TotalRipening,
    },
    {
      label: _t("total_kg_rooms", "Total KG in Ripening"),
      value: summaryData?.data.total_kg_in_ripening,
      icon: RoomKg,
    },
    {
      label: _t("cases_enter_sorting", "Cases in Sorting"),
      value: summaryData?.data.total_cases_in_sorting,
      icon: Sorting,
    },
    {
      label: _t("total_kg_sorting", "Total KG in Sorting"),
      value: summaryData?.data.total_kg_in_sorting,
      icon: KgEntered,
    },
  ];


  // const attendanceListItems = useMemo(() => {
  //   if (!attendanceOverviewData?.data) return [];

  //   const items = [
  //     {
  //       label: _t("attendance_total", "Total Employees"),
  //       value: attendanceOverviewData.data.total_employees,
  //       icon: TotalEmployee,
  //     },
  //   ];

  //   for (const [role, count] of Object.entries(
  //     attendanceOverviewData.data.roles
  //   )) {
  //     items.push({
  //       label: role.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()), // format label
  //       value: count,
  //       icon: EmployeeWashing,
  //     });
  //   }

  //   return items;
  // }, [attendanceOverviewData]);

  const AddEmployee = () => {
    setShowAddEmployment(true);
  };

  return (
    <div>
      {/* <h1 className="dashboard_heading">{_t("welcome", "Welcome, Super Admin")}</h1> */}
      {showAddEmployment && (
        <AddRipeningEmployeeData
          show={showAddEmployment}
          setShow={setShowAddEmployment}
          record={employeeSummaryData?.data}
        />
      )}
      <div className="overview cmn_card mb-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">{_t("overview", "Overview")}</h6>
          <DateSelector setDate={setDate} />
        </div>
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              // day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date,PROJECT_DATE_FORMAT)}
            />
          ))}
        </ul>
      </div>
      <RipeningCharts />
      {/* <div className="overview cmn_card mt-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">{_t("today_employees_title", "Today Employees Log")}</h6>
        </div>
        <ul className="m-0 grid_card_wrapper employee_list_grid">
          {isAttendanceLoading ? (
            <p>{_t("attendance_loading", "Loading attendance data...")}</p>
          ) : isAttendanceError ? (
            <p>{_t("attendance_error", "Error loading attendance data.")}</p>
          ) : (
            <>
              {attendanceListItems.map((list, index) => (
                <GridCardNew
                  key={index}
                  title={list.label}
                  value={list.value}
                  icon={list.icon}
                  day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date,PROJECT_DATE_FORMAT)}
                />
              ))}
            </>
          )}
        </ul>
      </div> */}
    </div>
  );
};

export default RipeningDashboard;
